import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { resetUpdatePassword, updatePassword } from "./update-password";

const initialState: ProcessingState = { processing: "idle" };

export const updatePasswordReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(updatePassword.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(updatePassword.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(updatePassword.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUpdatePassword, () => {
    return initialState;
  });
});
